import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552f204e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "mt-10 mb-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 薪资列表 ")
const _hoisted_6 = { style: {"width":"100%"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("完结")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("历史记录")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 删 除 ")
const _hoisted_11 = { type: "primary" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("填入：")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("转正调薪")
const _hoisted_14 = { type: "primary" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("填入：")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("尽孝金调整")
const _hoisted_17 = { type: "primary" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("填入：")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("员工离职")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")

import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { reactive, onBeforeMount, ref, inject } from "vue";
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/salaries/entries': fetchList,
  // 管理员验证
  'GET/isAdmin': isAdminApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 基础薪酬导入模板
  'GET/salaries/download/salary': salariesDownloadApi,
  // 尽孝金模板
  'GET/salaries/download/filial': downloadFilialApi,
  // 导出基础薪酬
  'GET/salaries/export': exportApi,
  // 完结
  'PUT/salaries/end': salariesEndApi,
  // 薪酬列表删除
  'DELETE/salaries/{detailId}': delSalariesApi,
  // 批量导入尽孝金
  'POST/salaries/import_filial': salariesImportFilialApi,
  // 批量导入基础薪资
  'POST/salaries/import_salary': SalariesImportApi,
  // 保存薪酬记录
  'POST/salaries/entries/org': saveSalaryApi,
  // 获取多条薪酬记录
  'GET/users/salary_details/{userId}': salaryDetailsApi,
  // 批量导入完结工资
  'POST/salaries/import_end': import_endApi,
} = Api



let { MI_height, MI_tableData, fetchData,
  MI_params, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify 
} = new tbMix(fetchList)

let companyList: any = ref([])
let orgList: any = ref([])
const isAdmin = ref<boolean>(false)
onBeforeMount(() => {
  fetchData()

  companyApi().then((rep) => {
    companyList.value = rep
  })
  organizationsApi().then((rep) => {
    orgList.value = rep
  })

  isAdminApi().then((rep: boolean) => {
    isAdmin.value = rep
  })
})

const searchEle: any = ref()
const searchObj: any = reactive({
  name: '', type: '', hiredTime: [], departureTo: '',
  departureFrom: '', orgId:'', companyId: '',
})
let searchConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'name',
    props: { placeholder: "请输入姓名", clearable: true },
  },
  {
    type: "SELECT",
    label: "员工类型",
    value: "",
    upKey: "type",
    options: [
      {label: "新入职员工", id: "NEW"},
      {label: "当月需转正人员", id: "PROBATION"},
      {label: "已转正", id: "FORMAL"},
    ],
    seleProps: {},
    props: { placeholder: "请选择员工类型", clearable: true },
  },
  {
    type: "SELECT",
    label: "公司",
    value: "",
    upKey: "companyId",
    options: companyList,
    placeholder: "请选择公司",
    // selectFunc: companyApi,
    props: { placeholder: '请选择公司', clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: "SELECT",
    label: "团队",
    value: "",
    upKey: "orgId",
    options: [],
    placeholder: "请选择团队",
    selectFunc: organizationsApi,
    props: { placeholder: '请选择团队', clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: "TIME",
    label: "入职日期",
    value: '',
    upKey: 'hiredTime',
    upProps: { startKey: 'start', endKey: 'end', },
    props: { 'value-format': 'YYYY-MM-DD', type: 'daterange', clearable: true }
},
]);
const searchHandle = () => {
  return fetchData({
    ...searchObj,
    start: searchObj.hiredTime?.[0],
    end: searchObj.hiredTime?.[1],
  })
};


// ================= 薪资列表 ===================
const multipleFg = ref<boolean>(false)
const historyFg = ref<boolean>(false)
let historyMulData = ref([])


const salaryForm: any = reactive({
  list: []
})
// 添加临时薪酬
const addAttednRow = () => {
  salaryForm.list.push({
    // 起薪日
    startedOn: '',
    // 团队
    orgId: '',
    // 公司
    companyId: multipleRow.companyId,
    // 基本工资
    salary: 0,
    // 职位津贴
    jobAllowance: 0,
    // 年度贡献奖
    postAllowance: 0,
    // 军阶奖
    rankAllowance: 0,
    // 其他补贴
    otherAllowance: 0,
    // 公司补助
    companyAllowance: 0,
    // 公司尽孝金
    filialAmount: 0,
    // 个人尽孝金
    personalAmount: 0,
  })
}
// 删除临时薪酬
const delTempSalary = (index?: any) => {
  salaryForm.list.pop()
}

let multipleRow: any = reactive({ type: '' })
// 个人薪酬list
let personalSalaryLength = ref(0)
const showSalaryList = (row: any) => {
  Object.assign(multipleRow, row)
  let type = searchConfig.value[1].value === '' ? 'ALL' : searchConfig.value[1].value
  multipleRow.type = type

  MI_identify.value = true
  salaryForm.list = []
  salaryDetailsApi({userId: row.userId, type: type})
    .then(rep => {
      personalSalaryLength.value = rep.length
      rep.map((e: any) => {
        salaryForm.list.push({ ...e, companyId: row.companyId })
      })
    })
    .finally(() => {
      multipleFg.value = true
      MI_identify.value = false
    })
  // 获取薪资历史记录
  historyFg.value = true
  salaryDetailsApi({userId: row.userId, record: true}).then(rep => {
    historyMulData.value = rep
  }).finally(() => {
    historyFg.value = false
  })

}
// 保存临时薪酬
const isSaveLoad = ref<boolean>(false)
const multipleSaveHandle = (params: any) => {
  if(!params.startedOn){
    ElMessage.warning('请选择起薪日')
    return
  }
  if(params.orgId === ''){
    ElMessage.warning('请选择团队')
    return
  }
  if(params.companyId === ''){
    ElMessage.warning('请选择公司')
    return
  }
  isSaveLoad.value = true
  saveSalaryApi({...params, userId: multipleRow.userId}).then(() => {

    ElMessage.success('保存成功')
    showSalaryList(multipleRow)
  }).finally(() => {
    isSaveLoad.value = false
  })
}

// 完结薪资
const isShowEnd = ref<boolean>(false)
const salaryEndEle = ref()
/* const salaryEndConfig = ref([
  {
    type: "TIME",
    label: "结束时间",
    value: '',
    upKey: 'endDate',
    rule: [{ required: true, message: '必选项', trigger: 'change' },],
    props: {type: 'date',clearable: false}
  },
]) */
const salaryEndObj: any = reactive({
  endDate: '',
  endReason: '',
  importDTO: {}
})
const salaryEndHandle = (row: any, origItem?: any) => {
  salaryEndEle.value.validate(() => {}).then((valid: boolean) => {
    if(!valid) return Promise.reject()
    return salariesEndApi(salaryEndObj)
  }).then(() => {
    isShowEnd.value = false
    showSalaryList(multipleRow)
		ElMessage.success('完结成功')
	}).finally(() => {
	})
  /* MI_modifyForm({}, salaryEndConfig, isShowEnd, async (params: any) => {
    await salariesEndApi({...params, importDTO: row})
    ElMessage.success('完结成功')
    isShowEnd.value = false
    showSalaryList(multipleRow)
  }) */
}
// 删除历史记录薪资
const multipleDeleteHnadle= async (params: any, origItem?: any) => {

  try {
    await ElMessageBox.confirm(
      '是否删除？',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )
    historyFg.value = true
    await delSalariesApi({detailId: params.detailId})
    ElMessage.success('删除成功')
    historyFg.value = false
  } catch (error) {
    historyFg.value = false
  }
  // 获取薪资历史记录
  historyFg.value = true
  salaryDetailsApi({userId: multipleRow.userId, record: true}).then(rep => {
    historyMulData.value = rep
  }).finally(() => {
    historyFg.value = false
  })
}

// 合计
const formatTotal = (row: any) => {
  return getNumber( row.salary + row.jobAllowance + row.postAllowance + row.otherAllowance + row.companyAllowance + row.rankAllowance )
}



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "基础薪酬-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).name) = $event)),
                      placeholder: "请输入姓名",
                      maxlength: "100",
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "员工类型:",
                  prop: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).type,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).type) = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "新入职员工",
                          value: "NEW"
                        }),
                        _createVNode(_component_el_option, {
                          label: "当月需转正人员",
                          value: "PROBATION"
                        }),
                        _createVNode(_component_el_option, {
                          label: "已转正",
                          value: "FORMAL"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司:",
                  prop: "companyId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).companyId) = $event)),
                      style: {"width":"310px"},
                      filterable: "",
                      placeholder: "请选择公司"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).orgId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                      placeholder: "请选择团队",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "入职日期:",
                  prop: "hiredTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).hiredTime,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).hiredTime) = $event)),
                      type: "daterange",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      clearable: "",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "离职日期起:",
                  prop: "departureFrom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).departureFrom,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).departureFrom) = $event)),
                      type: "date",
                      placeholder: "请选择日期",
                      clearable: "",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "离职日期止:",
                  prop: "departureTo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).departureTo,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).departureTo) = $event)),
                      type: "date",
                      placeholder: "请选择日期",
                      clearable: "",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (isAdmin.value)
        ? (_openBlock(), _createBlock(_component_TheUpBtn, {
            key: 0,
            upText: '导入基础薪酬',
            upFetch: _unref(SalariesImportApi),
            upParams: {},
            showBtn: true,
            onUpSuccess: _cache[9] || (_cache[9] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
            class: "mr-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_eptBtn, {
                exportFn: _unref(salariesDownloadApi),
                exportText: '下载基础薪酬模板',
                isDirect: true
              }, null, 8, ["exportFn"])
            ]),
            _: 1
          }, 8, ["upFetch"]))
        : _createCommentVNode("", true),
      (isAdmin.value)
        ? (_openBlock(), _createBlock(_component_TheUpBtn, {
            key: 1,
            upText: "批量导入完结工资",
            upConfig: [{
          label: '完结原因',
          value: '',
          upKey: 'endReason',
          props: { placeholder: '请输入完结原因', clearable: true },
        }],
            upFetch: _unref(import_endApi),
            upParams: {},
            showBtn: true,
            onUpSuccess: _cache[10] || (_cache[10] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
            class: "mr-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_eptBtn, {
                exportFn: _unref(salariesDownloadApi),
                exportText: '下载基础薪酬模板',
                isDirect: true
              }, null, 8, ["exportFn"])
            ]),
            _: 1
          }, 8, ["upFetch"]))
        : _createCommentVNode("", true),
      (isAdmin.value)
        ? (_openBlock(), _createBlock(_component_TheUpBtn, {
            key: 2,
            upText: '导入尽孝金',
            upFetch: _unref(salariesImportFilialApi),
            upParams: {},
            showBtn: true,
            onUpSuccess: _cache[11] || (_cache[11] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_eptBtn, {
                exportFn: _unref(downloadFilialApi),
                exportText: '下载尽孝金模板',
                isDirect: true
              }, null, 8, ["exportFn"])
            ]),
            _: 1
          }, 8, ["upFetch"]))
        : _createCommentVNode("", true),
      (isAdmin.value)
        ? (_openBlock(), _createBlock(_component_eptBtn, {
            key: 3,
            exportFn: _unref(exportApi),
            exportParam: _unref(MI_params),
            exportText: '导出基础薪酬'
          }, null, 8, ["exportFn", "exportParam"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(MI_tableData),
      border: "",
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "userName",
          label: "姓名",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "hiredTime",
          width: "120",
          label: "入职日期",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cardId",
          label: "证件号码",
          width: "180",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "companyName",
          label: "公司",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "orgName",
          label: "团队",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "基本工资",
          width: "95",
          prop: "salary",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "职位津贴",
          width: "95",
          prop: "jobAllowance",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "年度贡献奖",
          width: "95",
          prop: "postAllowance",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "其他补贴",
          width: "95",
          prop: "otherAllowance",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "公司补助",
          width: "95",
          prop: "companyAllowance",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "军阶奖",
          width: "95",
          prop: "rankAllowance",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "合计",
          width: "95",
          prop: "totalSalary",
          align: "right",
          formatter: formatTotal
        }),
        _createVNode(_component_el_table_column, {
          label: "单位养老保险",
          width: "110",
          prop: "companyEndowment",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人养老保险",
          width: "110",
          prop: "personalEndowment",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位医疗保险",
          width: "110",
          prop: "companyMedical",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人医疗保险",
          width: "110",
          prop: "personalMedical",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位工伤保险",
          width: "110",
          prop: "companyInjury",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人工伤保险",
          width: "110",
          prop: "personalInjury",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位生育保险",
          width: "110",
          prop: "companyMaternity",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人生育保险",
          width: "110",
          prop: "personalMaternity",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位失业保险",
          width: "110",
          prop: "companyUnemployment",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人失业保险",
          width: "110",
          prop: "personalUnemployment",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位公积金",
          width: "120",
          prop: "companyHousing",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人公积金",
          width: "120",
          prop: "personalHousing",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个税",
          prop: "personalTax",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人尽孝金",
          width: "110",
          prop: "personalAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "公司尽孝金",
          width: "110",
          prop: "filialAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (showSalaryList(scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      "page-size": _unref(size),
      total: _unref(MI_total),
      disabled: _unref(MI_identify),
      onSizeChange: _unref(MI_sizeChange),
      onCurrentChange: _unref(MI_pageChange),
      "page-sizes": [30, 50, 100, 300],
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
      class: "mt-10",
      layout: "sizes, prev, pager, next, total, jumper"
    }, null, 8, ["page-size", "total", "disabled", "onSizeChange", "onCurrentChange", "currentPage"]),
    _createVNode(_component_el_dialog, {
      title: "薪酬列表",
      top: "95px",
      width: "1400px",
      modelValue: multipleFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((multipleFg).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          height: "680px",
          class: "pr-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "adjustRef",
              "label-position": "top",
              model: _unref(salaryForm),
              inline: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salaryForm).list, (_row, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createVNode(_component_el_form_item, {
                      label: "起薪日：",
                      rules: [{ required: true, message: '请选择起薪日', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _row.startedOn,
                          "onUpdate:modelValue": ($event: any) => ((_row.startedOn) = $event),
                          placeholder: "请选择起薪日",
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "公司：",
                      rules: [{ required: true, message: '请选择公司', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "form-input",
                          modelValue: _row.companyId,
                          "onUpdate:modelValue": ($event: any) => ((_row.companyId) = $event),
                          placeholder: "请选择公司",
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyList), (com) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: com.name,
                                value: com.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "团队：",
                      rules: [{ required: true, message: '请选择团队', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "form-input",
                          modelValue: _row.orgId,
                          "onUpdate:modelValue": ($event: any) => ((_row.orgId) = $event),
                          placeholder: "请选择团队"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgList), (org) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: org.name,
                                value: org.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "基本工资：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.salary,
                          "onUpdate:modelValue": ($event: any) => ((_row.salary) = $event),
                          placeholder: "请输入基本工资",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "职位津贴：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.jobAllowance,
                          "onUpdate:modelValue": ($event: any) => ((_row.jobAllowance) = $event),
                          placeholder: "请输入职位津贴",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "年度贡献奖：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.postAllowance,
                          "onUpdate:modelValue": ($event: any) => ((_row.postAllowance) = $event),
                          placeholder: "请输入年度贡献奖",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "军阶奖励：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.rankAllowance,
                          "onUpdate:modelValue": ($event: any) => ((_row.rankAllowance) = $event),
                          placeholder: "请输入军阶奖励",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "其他补贴：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.otherAllowance,
                          "onUpdate:modelValue": ($event: any) => ((_row.otherAllowance) = $event),
                          placeholder: "请输入其他补贴",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "公司补助：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.companyAllowance,
                          "onUpdate:modelValue": ($event: any) => ((_row.companyAllowance) = $event),
                          placeholder: "请输入公司补助",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "公司尽孝金：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.filialAmount,
                          "onUpdate:modelValue": ($event: any) => ((_row.filialAmount) = $event),
                          placeholder: "请输入公司尽孝金",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "个人尽孝金：" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: _row.personalAmount,
                          "onUpdate:modelValue": ($event: any) => ((_row.personalAmount) = $event),
                          placeholder: "请输入个人尽孝金",
                          class: "form-input"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_button, {
                        onClick: ($event: any) => (multipleSaveHandle(_row)),
                        type: "primary",
                        loading: isSaveLoad.value
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick", "loading"]),
                      (index + 1 <= _unref(personalSalaryLength))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: ($event: any) => (isShowEnd.value = true, _unref(salaryEndObj).endDate = '', _unref(salaryEndObj).importDTO = _row, _unref(salaryEndObj).endReason = '')
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_divider)
                  ], 64))
                }), 256))
              ]),
              _: 1
            }, 8, ["model"]),
            _withDirectives(_createVNode(_component_el_button, {
              icon: "Plus",
              circle: "",
              onClick: addAttednRow
            }, null, 512), [
              [_directive_permission, 'Write']
            ]),
            (_unref(salaryForm).list.length > _unref(personalSalaryLength))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  icon: "Delete",
                  circle: "",
                  class: "ml-10",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (delTempSalary()))
                }, null, 512)), [
                  [_directive_permission, 'Write']
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _unref(historyMulData),
              border: "",
              "max-height": "800"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "startedOn",
                  label: "起薪日",
                  width: "130"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "endWith",
                  label: "完结日期",
                  width: "130"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "endReason",
                  label: "完结原因",
                  width: "130",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "companyName",
                  label: "公司",
                  width: "130",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "orgName",
                  label: "团队",
                  width: "130",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "salary",
                  label: "基本工资",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "jobAllowance",
                  label: "职位津贴",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "postAllowance",
                  label: "年度贡献奖",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "otherAllowance",
                  label: "其他补贴",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "companyAllowance",
                  label: "公司补助",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "rankAllowance",
                  label: "军阶奖",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "filialAmount",
                  label: "公司尽孝金",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "personalAmount",
                  label: "个人尽孝金",
                  width: "130",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (multipleDeleteHnadle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Delete']
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, historyFg.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "完结薪资",
      modelValue: isShowEnd.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((isShowEnd).value = $event)),
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = ($event: any) => (isShowEnd.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: salaryEndHandle,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "salaryEndEle",
          ref: salaryEndEle,
          model: _unref(salaryEndObj),
          "label-width": "auto",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "结束时间:",
              prop: "endDate",
              rules: [{ required: true, message: '请选择结束时间', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  "value-format": "YYYY-MM-DD",
                  modelValue: _unref(salaryEndObj).endDate,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(salaryEndObj).endDate) = $event)),
                  placeholder: "请选择结束时间"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "点击下方可快捷填入完结原因:" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_11, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(salaryEndObj).endReason = '转正调薪'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _hoisted_13
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(salaryEndObj).endReason = '尽孝金调整'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _hoisted_16
                  ]),
                  _createElementVNode("p", _hoisted_17, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(salaryEndObj).endReason = '员工离职'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _hoisted_19
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "完结原因:",
              prop: "endReason",
              rules: [{ required: true, message: '请选择完结原因', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  type: "textarea",
                  modelValue: _unref(salaryEndObj).endReason,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(salaryEndObj).endReason) = $event)),
                  placeholder: "请输入完结原因",
                  clearable: "",
                  rows: "4",
                  maxlength: "256"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})